<script lang="ts" setup>
import AuthLayout from "@/layouts/AuthLayout.vue";
import {
  KeyIcon,
  EyeIcon,
  EyeSlashIcon,
} from "tir-style-system/icons/outline";
import { TirPmInput } from "tir-pm-input";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-pm-button";

import { computed, onMounted, ref } from "vue";
import { TirPmPlate } from "tir-pm-plate";
import { TirPmStatusBudge } from "tir-pm-status-budge";

const firstPassword = ref("");
const secondPassword = ref("");

const showFirstPassword = ref(false);
const showSecondPassword = ref(false);
const showPlateWarning = ref(false);

import ApiService from "@/shared/api";

import { useRoute, useRouter } from "vue-router";

/**
 * Инициализация апи
 */
const api = new ApiService();

/**
 * Роутер
 */
let route = useRoute();
let router = useRouter();

/**
 * Токен из роута
 */
let routeQueryToken = route.query.token;
if (routeQueryToken[routeQueryToken.length - 1] == "/") {
  routeQueryToken = routeQueryToken.slice(0, -1);
}
console.log(routeQueryToken);

/**
 * Сообщение для ошибки
 */
const errorMessage = ref("");

/**
 * Лоадер для кнопки
 */
 const loadingRequest = ref(false)

/**
 * Перерасчет высоты
 */
 const loadingRequestComputed = computed(() => {
  return loadingRequest.value;
});

/**
 * Индикатор для совпадения паролей
 */
const isWithSuccessQual = computed(() => {
  return !!(
    firstPassword.value.length &&
    secondPassword.value.length &&
    firstPassword.value == secondPassword.value
  );
});
/**
 * Индикатор для смены видимости пароля
 */
const typeFirstPassword = computed(() => {
  return showFirstPassword.value ? "text" : "password";
});
/**
 * Индикатор для смены видимости пароля
 */
const typeSecondPassword = computed(() => {
  return showSecondPassword.value ? "text" : "password";
});

/**
 * Функция для восстановления пароля
 */
const onTypePassword = () => {};

/**
 * Функция для восстановления пароля
 */
const onRestorePassword = async () => {
  loadingRequest.value = true 
  try {
    if (
      firstPassword.value &&
      secondPassword.value &&
      firstPassword.value == secondPassword.value
    ) {
      let { IsSuccess, ErrorMessage } =
        await api.Main.UsersService.resetPasswordAsync({
          Token: routeQueryToken,
          NewPassword: secondPassword.value,
        });
      console.log(IsSuccess);
      if (!IsSuccess) {
        console.log(IsSuccess);
        showPlateWarning.value = true;
        errorMessage.value = ErrorMessage;
      } else {
        router.push("/login");
      }
    } else {
      showPlateWarning.value = true;
      errorMessage.value = "Пароли не совпадают";
    }
  } catch (err) {
    console.log(err);
    showPlateWarning.value = true;
    errorMessage.value = err.ErrorMessage;
  }
  loadingRequest.value = false 
};

const $currentComponentWrapper = ref(null);
const currentHeightComponent = ref(0);

/**
 * Проверка токена
 */
onMounted(() => {
  currentHeightComponent.value = $currentComponentWrapper.value?.offsetHeight;
  if (!route.query.token) {
    router.push("/login");
  }
});

defineExpose({
  changerMethodFromComponent: onRestorePassword,
  currentHeightComponent: currentHeightComponent,
  isLoadingIntoComponent: loadingRequestComputed,
});
</script>

<template>
  <div class="layout-login__body" ref="$currentComponentWrapper">
    <img class="layout-login__logo" src="../../assets/images/Logo.svg" alt="" />
    <div class="layout-login__wrap-input">
      <div class="layout-login__desc-input">Восстановление доступа</div>

      <TirPmPlate
        isShow
        variant="negative"
        isRounded
        class="layout-login__alert"
        v-show="showPlateWarning"
      >
        <template #leftAddon>
          <TirPmStatusBudge status-color="negative" status-icon-type="alert" />
        </template>
        <template #titleSlot> Ошибка </template>
        <template #subtitleSlot>{{ errorMessage }} </template>
      </TirPmPlate>
      <TirPmInput
        isAutocomplete
        label="Пароль"
        :type="typeFirstPassword"
        @input="onTypePassword"
        v-model="firstPassword"
        placeholder=""
        :isWithHint="false"
        :isWithSuccess="isWithSuccessQual"
        :isWithError="showPlateWarning"
      >
        <template #leftInputAddons>
          <div class="layout-login__input-addons">
            <KeyIcon></KeyIcon>
          </div>
        </template>
        <template #hintMessage></template>
        <template #rightInputAddons>
          <div
            class="layout-login__input-addons layout-login__input-addons--action"
            :class="{
              'layout-login__input-addons--show': firstPassword.length,
            }"
          >
            <EyeIcon
              @click="showFirstPassword = !showFirstPassword"
              v-if="!showFirstPassword"
            ></EyeIcon>
            <EyeSlashIcon
              @click="showFirstPassword = !showFirstPassword"
              v-if="showFirstPassword"
            ></EyeSlashIcon>
          </div>
        </template>
      </TirPmInput>
      <TirPmInput
        isAutocomplete
        label="Повторите пароль"
        :type="typeSecondPassword"
        @input="onTypePassword"
        v-model="secondPassword"
        placeholder=""
        :isWithHint="false"
        :isWithSuccess="isWithSuccessQual"
        :isWithError="showPlateWarning"
      >
        <template #leftInputAddons>
          <div class="layout-login__input-addons">
            <KeyIcon></KeyIcon>
          </div>
        </template>
        <template #hintMessage></template>
        <template #rightInputAddons>
          <div
            class="layout-login__input-addons layout-login__input-addons--action"
            :class="{
              'layout-login__input-addons--show': secondPassword.length,
            }"
          >
            <EyeIcon
              @click="showSecondPassword = !showSecondPassword"
              v-if="!showSecondPassword"
            ></EyeIcon>
            <EyeSlashIcon
              @click="showSecondPassword = !showSecondPassword"
              v-if="showSecondPassword"
            ></EyeSlashIcon>
          </div>
        </template>
      </TirPmInput>
    </div>
  </div>
</template>
